module.exports = __webpack_public_path__ + "img/img (21).c459551b.jpg";